<template>
  <v-form class="col-12">
    <v-text-field
      v-model.trim="$v.user.email.$model"
      prepend-icon="mdi-email"
      name="email"
      :error-messages="emailError"
      autocomplete="off"
      label="E-mail"
      type="email"
      :disabled="disableEmail"
      @blur="pesquisaHost"
    />
    <!-- <v-select
      v-model="$v.user.hostId.$model"
      :items="listHost"
      item-text="descr"
      item-value="hostId"
      prepend-icon="mdi-map-search"
      :error-messages="hostIdError"
      :disabled="disableHost"
      label="Local"
    /> -->
    <v-text-field
      :append-icon="showPwdBd ? 'mdi-eye-off' : 'mdi-eye'"
      :type="showPwdBd ? 'text' : 'password'"
      @click:append="showPwdBd = !showPwdBd"
      v-model.trim="$v.user.pwd.$model"
      :error-messages="passwordError"
      :disabled="disableHost"
      prepend-icon="mdi-lock"
      ref="pwd_login"
      disable
      name="password"
      label="Senha"
    />
    <v-spacer />
    <div class="col-12 d-flex justify-space-between">
      <v-spacer></v-spacer>
      <v-btn
        text
        class="text-decoration-underline caption px-0 py-0"
        @click="dialogRecovery=true"
        :disabled="(user.hostId.length<=0)"
        >Esqueceu a senha?</v-btn
      >
    </div>
    <div class="col-12 d-flex justify-lg-space-between">
      <v-btn large @click.prevent="voltar"> Voltar </v-btn>
      <v-btn
        :disabled="$v.$invalid || disableSubmit ? true : false"
        color="primary"
        large
        type="submit"
        @click.prevent="submit"
      >
        Continuar
      </v-btn>
    </div>
    <v-dialog v-model="dialogRecovery"   persistent max-width="360">
      <v-card>
        
        <v-card-title class="headline">
          Aviso
        </v-card-title>
        <v-card-text>
          <p class="text-subtitle-2">A senha será alterada e enviada para seu email, deseja prosseguir?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialogRecovery = false"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary darken-1" text @click="openEsqueceuSenha">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>


<script>
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  name: "LoginHost",
  data() {
    return {
      user: {
        email: "",
        hostId: "",
        pwd: ""
      },
      disabledBtnForgetSenha: true,
      listHostUser: [],
      disableEmail: false,
      disableHost: false,
      showPwdBd: false,
      disableBtn: false,
      dialogRecovery: false
    }
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      // hostId: {
      //   required,
      //   minLength: minLength(36)
      // },
      pwd: {
        required,
        minLength: minLength(6)
      }
    }
  },
  computed: {
    emailError() {
      const errors = [];
      const email = this.$v.user.email;
      if (!email.$dirty) {
        return errors;
      }
      !email.required && errors.push("Email é obrigatório");
      !email.email && errors.push("Email inválido");
      return errors;
    },
    // hostIdError() {
    //   const errors = [];
    //   const input = this.$v.user.hostId;
    //   if (!input.$dirty) {
    //     return errors;
    //   }
    //   !input.required && errors.push("Local é obrigatorio");
    //   !input.minLength && errors.push(`Local inválido`);
    //   return errors;
    // },
    passwordError() {
      const errors = [];
      const password = this.$v.user.pwd;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push("Senha é obrigatorio");
      !password.minLength && errors.push(`Senha inválida`);
      return errors;
    },
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      }
    }
  },
  watch: {
    "user.email"(value) {
      this.$store.dispatch("setEmailRecuperacao", value);
      this.$store.dispatch("setEmail", value);
    },
    emailLogin(value) {
      if ((value != null) & (value.length > 0)) {
        localStorage.setItem("email", value);
        this.user.email = value;
        this.$store.dispatch("setEmail", value);
      }
    },
    listHost: {
      handler: function(value) {
        if ((value != null) & (value.length > 0)) {
          this.listHostUser = value;
          this.user.hostId = value[0].hostId;
          this.$store.dispatch("setListHost", value);
        }
      },
      immediate: true
    },
  },
  created() {
    this.user.email = this.emailLogin;
  },
  props: {
    emailLogin: String,
    listHost: Array
  },
  methods: {
    voltar() {
      this.$emit("action", { page: 1 });
    },
    openEsqueceuSenha() {
      let input = this.user.email;
      if (
        (input.$invalid || input.$dirty) &&
        (!input.required || !input.email)
      ) {
        input.$reset();
        input.$touch();
        this.$store.dispatch("setMsgError", "Email é obrigatório!");
        this.$store.dispatch("setDisplayMsgErr", true);
        return false;
      }
      let data = {
        user: this.user.email,
        hostId: this.user.hostId
      };

      this.$alertme.resetPwd(data).then(
        res => {
          this.$store.dispatch("MsgSucces", res.data.message);
          this.$store.dispatch("displayMsgSuccess", true);
        },
        e => {
          if (e.response) {
            this.$store.dispatch("setMsgError", e.response);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        }
      );
    },
    pesquisaHost() {

      
      // if (this.user.email != this.emailLogin) {
        this.$alertme
          .listHost({ hostId: "", user: this.user.email })
          .then(res => {
            if(res.data.value.length>0) {
              localStorage.setItem("email", this.user.email);
              this.$store.dispatch("setEmail", this.user.email);
              this.user.hostId = res.data.value[0].hostId;
              this.listHostUser = [ ...res.data.value];
              this.$alertme.localStoreHostUser(this.user.email,  [ ...res.data.value]);
              this.$refs.pwd_login.focus()
            }
          })
          .catch(e => {
            if (e.response) {
              this.$store.dispatch("setMsgError", e.response);
              this.$store.dispatch("setDisplayMsgErr", true);
              this.$store.dispatch("resetToken");
            }
          });
      // }
    },
    submit() {
      this.disableSubmit = true;
      let data = {
        user: this.user.email,
        pwd: this.$alertme.md5(this.user.pwd),
        hostId: this.user.hostId
      };
      localStorage.setItem("email", this.user.email);
      this.$store.commit("setEmail", this.user.email);
      let pagina = "home";
      this.$alertme.signIn(data).then(
        res => {
          this.disableSubmit = false;
          //exibi msg
          if (res.data.message && res.data.message != "ok") {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
            return;
          }
          this.$store.dispatch("MsgSucces", "Login efetuado com sucesso!");
          this.$store.dispatch("displayMsgSuccess", true);
          this.$store.dispatch("setEmail", this.user.email);
          this.$store.dispatch("setToken", true);
          this.$store.dispatch("setListHost", this.listHostUser);
          this.$store.dispatch("setHostActive", this.user.hostId);
          this.$store.dispatch("setPwd", this.$alertme.md5(this.user.pwd));
          let host = this.$alertme.getInfoHostUser(
            this.user.email,
            this.user.hostId
          );
          host.mod = res.data.mod;
          if (
            !this.$alertme.setAuthHostUser(
              this.user.email,
              this.user.hostId,
              host
            )
          ) {
            this.$store.dispatch("setMsgError", "Erro ao realizar login");
            this.$store.dispatch("setDisplayMsgErr", true);
            return false;
          }
          //buscando perfil
          this.$alertme.getPerfil({ hostId: this.user.hostId }).then(
            res => {
              if (res.data.status) {
                this.$store.dispatch("setPerfil", {});
              } else {
                this.$store.dispatch("setPerfil", res.data.value);
              }
              this.$router.push({
                name: pagina,
                params: { hostId: this.user.hostId }
              });
            },
            () => {
              this.$store.dispatch("setPerfil", {});
            }
          );
        },
        () => {
          this.disableSubmit = false;
          this.$store.dispatch("resetToken");
        }
      );
    }
  }
};
</script>